import * as React from "react";
const ArrowBottomLeft = ({ size, ...props }) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24", ...props }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", d: "M12.8733 17.1269L12.8733 16.1271L8.58049 16.1264L17.1266 7.58028L16.4195 6.87317L7.87338 15.4193L7.87338 11.1271L6.87354 11.1271L6.87354 17.1262L12.8733 17.1269Z", clipRule: "evenodd" }));
ArrowBottomLeft.displayName = "ArrowBottomLeft";
var ArrowBottomLeft_default = ArrowBottomLeft;
export {
  ArrowBottomLeft_default as default
};
